<template>
  <NuxtLayout class="app-entry" :name="envStore.isMobile ? 'mobile' : 'default'">
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useNuxtApp, useHead } from '#imports';
import { useSSRContext } from 'vue';
import { useEnvironmentStore } from './src/store';
import { getRuntimeContext } from './server/helpers/server';
import { useUserStore } from './src/store/modules/user';
import { isMobile, getPlatform } from './server/utils/device';
import { miniProgramToPc } from './src/api/modules/exam';
import { getUrlQuery } from '@/src/utils/urlHelper';
import { APIEventEmitter } from '~/src/services/event';
import { EventNameMap } from '~/src/services/event/constants';

console.log('app vue entry.');

const nuxtApp = useNuxtApp();

const envStore = useEnvironmentStore();
// 全局用户信息
const userStore = useUserStore();
const route = useRoute();

if (process.server) {
  const ssrContext = useSSRContext();
  const runtimeContext = getRuntimeContext(ssrContext?.event);
  console.log('runtimeContext.isMobile', runtimeContext.isMobile);
  envStore.setIsMobile(runtimeContext.isMobile);
  envStore.setPlatform(runtimeContext.platform);
}

if (envStore.isMobile === undefined) {
  envStore.setIsMobile(isMobile(navigator?.userAgent));
}

if (!envStore.platform) {
  envStore.setPlatform(getPlatform(navigator?.userAgent || ''));
}

console.log('platform', envStore.platform);

if (envStore.platform === 'miniProgram') {
  // 小程序环境 登录一下
  if (process.client) {
    let token = getUrlQuery('token');
    let userSubject = getUrlQuery('userSubject'); // 小程序那边的科目id

    try {
      token && (await miniProgramToPc({ 'user-token': token }));
      userSubject && userStore.updateMiniProgramSubjectId(userSubject);
    } catch (error) {
      APIEventEmitter.emit(EventNameMap.API_UN_LOGIN, error);
      console.error(error);
    }
  }
} else {
  // 其他环境不需要
  userStore.updateMiniProgramSubjectId('');
}

if (process.client) {
  await userStore.updateUserInfo({
    nuxtApp,
  });

  if (userStore.isLogin) {
    await Promise.all([userStore.getUserSubjectId({ nuxtApp })]);
  }
}
</script>
